import { synapse } from '@ublique/platform'
import { BASE_URL } from 'config'
import isEmpty from 'lodash/isEmpty'
import { saveAs } from 'file-saver'
import moment from 'moment'

async function executeFetch(url, body, type) {
  return synapse.fetch(url, { method: type }, body)
}

async function executeFetchWithExport(
  url,
  method = 'GET',
  body = null,
  defaultFilename = 'FileName'
) {
  try {
    const res = await synapse.fetch(
      url,
      {
        method
      },
      body
    )

    if (res.status !== 200) {
      console.error(`Couldn't get data`)
      return null
    }

    // There is a need to remove the double quotes from the ends of the string,
    // because now synapse transforms them into underscores,
    // modifying the extension and it's not readable
    const fileName = !isEmpty(res.fileName)
      ? res.fileName.replaceAll('"', '')
      : defaultFilename

    saveAs(res.body, fileName)

    return res.body
  } catch (err) {
    console.error(err)
    return null
  }
}

// ---------> Dashboard operativa <----------
export const fetchDataForDashboardOperativa = async (scenarioId, uom, body) => {
  const url = `${BASE_URL}/output/${scenarioId}/dashboard-operativa?uom=${uom}`
  return await executeFetch(url, body, 'POST')
}
// ------------------------------------------

// ---------> Tabella dettaglio <----------
export const fetchDetailTable = async (scenarioId, body) => {
  const url = `${BASE_URL}/output/${scenarioId}/tabella-dettaglio/table`
  return await executeFetch(url, body, 'POST')
}

export const fetchDetailTableExport = async (scenarioId, body, lng) => {
  const url = `${BASE_URL}/output/${scenarioId}/tabella-dettaglio/table/export?lng=${lng}`
  const dateTime = moment().format('YYYYMMDD-HHmmss')
  const defaultFilename = `TabellaDettaglio_${dateTime}`

  return await executeFetchWithExport(url, 'POST', body, defaultFilename)
}
// ------------------------------------------
